import { createApp } from '@app/adapters/create-app'
import PastMeetings from '../screens/past-meetings/components/past-meetings'
import createMeetingPreparationStore from '@app/application/client_meetings/screens/preparation/store/meeting-preparation-store'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='client-past-meetings']").each(function () {
    const store = createMeetingPreparationStore({
      firmId: Silverfin.currentFirmId,
      companyId: Silverfin.currentCompanyId,
      pastMeetings: true,
    })
    const app = createApp(PastMeetings)
    app.use(store)
    app.mount(this)
  })
})
